import { Action, action } from 'easy-peasy';
import { StoreModel } from '../store';

export interface AuthLocalActions {
  setIsAuthenticated: Action<StoreModel, boolean>;
  reset: Action<StoreModel, void>;
  setUserData: Action<StoreModel, Record<string, unknown>>;
}

export default {
  setIsAuthenticated: action((state, payload: boolean) => {
    state.isAuthenticated = payload;
  }),
  reset: action((state) => {
    const stateKeys = Object.keys(state) as (keyof typeof state)[];
    stateKeys.forEach((key) => {
      if (key === 'isAuthenticated' || key === 'lastLoginEmail') {
        // don't set isAuthenticated during reset as it would navigate to the Login Screen immediately
        // which as well modifies the state and therefore conflicts with this reset action (it restores the state)
      } else if (Array.isArray(state[key])) {
        (state[key] as unknown) = [];
      } else if (typeof state[key] === 'object') {
        if (key === 'selfTrainingSelection') {
          state[key] = {
            Sprechen: false,
            Verstehen: false,
            Lesen: false,
            Schreiben: false,
          };
        } else {
          (state[key] as unknown) = {};
        }
      } else {
        (state[key] as unknown) = false;
      }
    });
  }),
  setUserData: action((state, payload: Record<string, unknown>) => {
    state.signedInUser = payload;
  }),
} satisfies AuthLocalActions;
